import { style } from '@vanilla-extract/css';

export const buttonContainer = style({
  paddingTop: 'var(--wt-button-padding-top)',
  paddingBottom: 'var(--wt-button-padding-bottom)',
  paddingLeft: 'var(--wt-padding)',
  paddingRight: 'var(--wt-padding)',
  wordBreak: 'break-word',
  width: '100%',
  textAlign: 'var(--button-alignment)',
});

export const button = style({
  display: 'inline-block',
  borderRadius: 'var(--post-button-radius)',
  backgroundColor: 'var(--custom-background-color, var(--wt-button-background-color))',
  color: 'var(--custom-text-color, var(--wt-button-text-color))',
  fontFamily: 'var(--wt-button-font-family)',
  fontSize: 'var(--button-font-size, var(--wt-button-font-size))',
  fontWeight: 'var(--wt-button-font-weight)',
  padding: 'var(--button-padding, var(--wt-button-padding))',
  cursor: 'pointer',
  lineHeight: 'var(--button-line-height)',
});
